/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Video_Export_Alpha_ProgressInputs */



/**
* | output |
* | --- |
* | "Exporting alpha video: {percent}%" |
*
* @param {Video_Export_Alpha_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_progress = /** @type {((inputs: Video_Export_Alpha_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation video alpha : ${i?.percent}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Alpha-Video exportieren: ${i?.percent}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione video alfa: ${i?.percent}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео: ${i?.percent}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando vídeo alfa: ${i?.percent}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出 Alpha 视频：${i?.percent}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アルファビデオをエクスポートしています: ${i?.percent}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात किया जा रहा है: ${i?.percent}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando vídeo alfa: ${i?.percent}%`)
	return /** @type {LocalizedString} */ (`Exporting alpha video: ${i?.percent}%`)
});